import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';
import {
  requestRequestHelpSuccess,
  requestRequestHelpFailure,
  requestRequestHelpUpdateSuccess,
  requestRequestHelpUpdateFailure,
} from './actions';

import { requestHelp, requestHelpUpdate } from './types';

const logger = new Logger('Saga:FundingSearchRequestHelp');

export function* requestRequestHelpSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.request_help', { fundingSearchId: action.fundingSearchId }),
    );

    yield put(requestRequestHelpSuccess(response.data));
  } catch (error) {
    logger.error('Failed to request Request Help client', error);
    yield put(requestRequestHelpFailure(error));
  }
}

export function* requestRequestHelpUpdateSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    yield call(
      authApiService.post,
      routerService.generate('api.request_help', { fundingSearchId: action.fundingSearchId }),
      action.payload,
    );

    yield put(requestRequestHelpUpdateSuccess());
    action.promise.resolve();
  } catch (error) {
    logger.error('Failed to request Request Help Update client', error);
    yield put(requestRequestHelpUpdateFailure(error));
    action.promise.reject();
  }
}

export default function* requestHelpSaga() {
  return yield all([
    takeLatest(requestHelp.request, requestRequestHelpSaga),
    takeLatest(requestHelpUpdate.request, requestRequestHelpUpdateSaga),
  ]);
}
